import { render, staticRenderFns } from "./JsaReminderEdit.vue?vue&type=template&id=a2f000dc"
import script from "./JsaReminderEdit.vue?vue&type=script&lang=js"
export * from "./JsaReminderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports